import { render, staticRenderFns } from "./ServerEditor.vue?vue&type=template&id=8dee0fd6&"
import script from "./ServerEditor.vue?vue&type=script&lang=js&"
export * from "./ServerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports